import React, { useEffect, useContext } from "react";

import { t } from "i18next";
import { Trans } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import SubscriptionPlansCards from "../../components/Cards/SubscriptionPlansCards";
import { isAuthorized } from "../../utils/RolesHelpers";
import { ROLES } from "../../utils/constants";
import { DASHBOARD_ROUTES } from "../../utils/RoutesConstant";
import Navbar from "../../components/Navbars/Navbar";
import CalendarIcon from "../../assets/images/calendar.png";
import { UserContext } from "../../lib/MainContext";

const LicenseExpirationView = () => {
    const { user: currentUser, setUser } = useContext(UserContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (currentUser && isLicenseValid(currentUser))
            navigate(DASHBOARD_ROUTES.Overview);
    }, [currentUser]);

    const isAuthorizedToPay = () => {
        return isAuthorized(
            [ROLES.partnerAdmin, ROLES.support],
            [currentUser?.role]
        );
    };

    const isLicenseValid = (user) => {
        return (
            user?.organization?.isLicenseValid || user.role === ROLES.superAdmin
        );
    };

    const isAccessRestricted = () => {
        const userOrganization = currentUser?.organization;
        return (
            !userOrganization?.isLicenseValid &&
            !userOrganization?.isLicenseInExtendedPeriod
        );
    };

    const getExpirationMessage = () => {
        return t(
            isAuthorizedToPay()
                ? "licenseExpiredWithNoExtension"
                : "licenseExpiredInferiorUser"
        );
    };

    return (
        <>
            <Navbar isRestricted={isAccessRestricted()} />
            <div className="main-content w-full m-0">
                <div className="flex flex-col w-full justify-center items-center gap-5">
                    <div className="w-1/6 h-1/6">
                        <img src={CalendarIcon} />
                    </div>
                    <div className="flex flex-col justify-center items-center gap-2">
                        <h3 className="text-primary-color-orange text-3xl">
                            <Trans i18nKey="licenseExpired">
                                License Expired
                            </Trans>
                        </h3>
                        <p className="text-primary-color-blue text-md text-center">
                            {getExpirationMessage()}
                            {!isAccessRestricted() && (
                                <Trans i18nKey="licenseExpiredGetBackToDashboard">
                                    or continue using NeoSpectra platform
                                    <Link
                                        className="underline text-blue-600"
                                        to={DASHBOARD_ROUTES.Overview}
                                    >
                                        click here
                                    </Link>
                                </Trans>
                            )}
                        </p>
                    </div>
                    {isAuthorizedToPay() && (
                        <SubscriptionPlansCards
                            currentUser={currentUser}
                            setCurrentUser={setUser}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default LicenseExpirationView;
